import { apiCallAdmin } from "../../service/api-service.js";

export const getOrgLogoApi = async () => 
  (await apiCallAdmin("get", "get_org_image")).data;

export const getProfileDetailsApi = async () => 
  apiCallAdmin("get", "basicprofile");
export const updateProfileImageApi = async (data) => 
  apiCallAdmin("post", "user/image_update", data);
export const reportAnIssueApi = async (data) => 
  apiCallAdmin("post", "report_issue", data);

export const getReportIssueTypeApi = async () => 
  (await apiCallAdmin("get", "get_issue_type")).data;

export const getFAQListApi = async () => 
  (await apiCallAdmin("get", "help?application=Asset")).data;

export const getOrgListApi = async () => 
  apiCallAdmin("get", "get_enrolled_orgs");

export const getSwitchAccountApi = async (id) => 
  apiCallAdmin("get", `switch_org/${id}`);

export const getRolePermissionApi = async (id) => 
  apiCallAdmin("get", `get_role_permission/${id}`);

export const getRoleTypeApi = async () => 
  apiCallAdmin("get", "get_role_type");
